import { createContext } from 'react';
export const MobileFilterPanelContext = /*#__PURE__*/createContext({
  openFilterPanel: undefined,
  onApplyFilters: () => {},
  onCloseFilterPanel: () => {},
  onOpenFilterPanel: () => {}
});